export default [
	{
		start: 0.05,
		end: 3,
		text: 'Il y en a beaucoup trop !'
	}
]
